import { Component, input, output } from "@angular/core";
import { IAllSearch, StatusInfo } from "../../../interfaces";
import { ArcusCustomerView } from "../../../interfaces/arcus/ArcusCustomerView";
import { MatDialog } from "@angular/material/dialog";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { HighlightDirective } from "../../directives/highlight.directive";
import { RouterLink } from "@angular/router";

@Component({
    selector: "customer-result",
    templateUrl: "./customer-result.component.html",
    styleUrl: "./customer-result.component.scss",
    imports: [
        NgClass,
        MatIcon,
        MatMiniFabButton,
        MatTooltip,
        MatMenuTrigger,
        HighlightDirective,
        MatMenu,
        MatMenuItem,
        RouterLink,
    ],
})
export class CustomerResultComponent {
    item = input.required<IAllSearch>();
    searchTerm = input.required<string>();
    shortcutClick = output<void>();

    constructor(private dialog: MatDialog) {}

    get fullAddress(): string {
        const parts = [this.item().Address1, this.item().City, this.item().State, this.item().ZIP].filter(Boolean);

        return parts.join(", ");
    }

    get primaryId(): string {
        return `${this.item().ID} - ${this.item().Name}`;
    }

    get backgroundClass(): string {
        const status = this.customerStatus;
        if (status.level === "danger") return "customer-danger";
        if (status.level === "warning") return "customer-warning";

        return "";
    }

    get customerStatus(): StatusInfo {
        const { BlockCredit, CODDrivCollect, Credit, CreditLimit, AverageBill } = this.item();

        if (BlockCredit && CODDrivCollect) {
            return { level: "warning", text: "COD Only" };
        }

        if (BlockCredit && !CODDrivCollect) {
            return { level: "danger", text: "Credit Blocked" };
        }

        if (!BlockCredit && (Credit ?? 0) >= (CreditLimit ?? 0)) {
            return { level: "danger", text: "Over Credit" };
        }

        if (
            !BlockCredit &&
            (AverageBill ?? 0) > 0 &&
            (Credit ?? 0) < (CreditLimit ?? 0) &&
            (AverageBill ?? 0) * 3 + (Credit ?? 0) >= (CreditLimit ?? 0)
        ) {
            return { level: "warning", text: "Almost Over Credit" };
        }

        return { level: "normal" };
    }

    formatCurrency(value?: number): string {
        if (value === undefined || value === null) return "$0";
        return `$${value.toLocaleString()}`;
    }

    gridButton() {
        this.shortcutClick.emit();
    }

    contactButton() {
        this.shortcutClick.emit();
        this.customerContactsDialog({ ID: this.item().ID } as ArcusCustomerView);
    }

    customerContactsDialog(customer: ArcusCustomerView) {
        import("../../../Shared/customer-contacts-dialog/customer-contacts-dialog.component").then(
            ({ CustomerContactsDialogComponent }) => {
                this.dialog.open(CustomerContactsDialogComponent, {
                    width: "1000px",
                    data: {
                        customer: customer,
                        branch: null,
                        readOnly: true,
                    },
                });
            }
        );
    }
}
